/**
 * Illustrative monthly savings model for marketing calculator.
 * Combines delay-pool economics (orders × delay cost) with fleet manual-effort proxy.
 */
export function estimateMonthlySavingsUsd(ordersPerDay: number, riders: number, avgDelayCostPerOrder: number): {
  total: number;
  fromDelays: number;
  fromUtilization: number;
  fromManual: number;
} {
  const monthlyOrders = Math.max(0, ordersPerDay) * 30;
  const r = Math.max(0, riders);
  const c = Math.max(0, avgDelayCostPerOrder);
  const pool = monthlyOrders * c;
  const fromDelays = pool * 0.3;
  const fromUtilization = pool * 0.25;
  const fromManual = r * 200 * 0.8;
  const total = Math.round(fromDelays + fromUtilization + fromManual);
  return {
    total,
    fromDelays: Math.round(fromDelays),
    fromUtilization: Math.round(fromUtilization),
    fromManual: Math.round(fromManual),
  };
}
